import {useTranslation} from 'react-i18next';

import {Card} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {BillingPlatformTransaction} from 'types';

import {TransactionsGrid} from './TransactionsGrid';
import {TransactionsTable} from './TransactionsTable';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.BILLING.TRANSACTIONS;

type Props = {
    transactions: BillingPlatformTransaction[];
}

export const Transactions: React.FC<Props> = ({transactions}) => {
    const {t} = useTranslation();

    return (
        <Card>
            <div className='tw-ts-h5-bold md:tw-ts-h3-bold tw-mb-4'>{t(T_KEYS.TITLE)}</div>
            <TransactionsTable transactions={transactions} />
            <TransactionsGrid transactions={transactions} />
        </Card>
    );
};